/* eslint-disable jsx-a11y/img-redundant-alt */
import React from "react";
import { ImageTile } from "./InactivePage";

interface Props {
  categories: ImageTile[];
}

const PopularCategories = ({ categories }: Props) => {
  function getPopularCategories() {
    if (categories.length > 0) {
      return categories.map((category) => {
        return (
          <a
            href={category.url}
            target="_blank"
            rel="noopener noreferrer"
            className="card-item"
            key={category.title}
          >
            <div className="card-item__inner">
              <img
                src={category.imageUrl}
                alt="category image"
                className="card-item__img"
              />
              <h3 className="card-item__title">{category.title}</h3>
            </div>
          </a>
        );
      });
    }

    return [];
  }

  return (
    <div className="card-grid">
      <h2 className="card-grid__headline">Shop Popular Categories</h2>
      <div className="card-grid__row">{getPopularCategories()}</div>
    </div>
  );
};

export default PopularCategories;
